import React from 'react';
import {
  MDBEdgeHeader,
  MDBFreeBird,
  MDBContainer,
  MDBCol,
  MDBRow,
  MDBCardBody,
  MDBIcon,
} from 'mdbreact';
import './HomePage.css';
import logo from "./../assets/logo.jpg";
import back from "./../assets/sensorium.jpeg";
import FirebaseConfig from './../config/FirebaseConfig';

class HomePage extends React.Component {
  scrollToTop = () => window.scrollTo(0, 0);

  logEvent(){
    FirebaseConfig.analytics().logEvent('screen_view','playStoreDownloadClick')
  }

  render() {
    return (
      <>
        <MDBEdgeHeader color='indigo darken-3' className='sectionPage' />
        <div className='mt-3 mb-5'>
          <MDBFreeBird>
            <MDBRow>
              <MDBCol
                md='10'
                className='mx-auto float-none white z-depth-1 py-2 px-2'
              >
                <MDBCardBody className='text-center'>
                  <h2 className='h2-responsive mb-4'>
                    <strong className='font-weight-bold'>
                      <img
                        src={logo}
                        alt='logo'
                        className='pr-2'
                        width='70px'
                        height='85px'
                      />
                      Sensorium App
                    </strong>
                  </h2>
                  <MDBRow />
                  <p>A social network for sensies around the world.</p>
                  <MDBRow className='d-flex flex-row justify-content-center row'>
                    <a
                      className='border nav-link border-light rounded mx-2 mb-2'
                      href='https://play.google.com/store/apps/details?id=com.sensorium.sensoriumapp'
                      target='_blank'
                      rel='noopener noreferrer'
                      onClick={this.logEvent()}
                    >
                      <MDBIcon icon='download' className='mr-2' />
                      <span className='font-weight-bold'>Download Android App</span>
                    </a>
                  </MDBRow>
                </MDBCardBody>
              </MDBCol>
            </MDBRow>
          </MDBFreeBird>
          <MDBContainer>
            <MDBRow>
              <MDBCol md='12' className='mt-4'>
                <h2 className='text-center my-5 font-weight-bold'>
                  Why?
                </h2>
                <p className='text-center text-muted mb-1'>
                    <b>Sensorium</b> was born from the fans for the fans.
                </p>
                <p className='text-center text-muted mb-1'>
                    This project is aimed to provide a tool that can help create connections between people that share core human values.
                </p>
                <hr />
              </MDBCol>
            </MDBRow>
            <MDBRow>
              <MDBCol md='12' className='mt-4'>
                <h2 className='text-center my-5 font-weight-bold'>
                  Privacy
                </h2>
                <p className='text-center text-muted mb-1'>
                    In a very short notice, we are letting you know that your data on the sensorium app will never be shared with anyone.
                </p>
                <p className='text-center text-muted mb-1'>
                    We have technological mechanisms to prevent unauthorized data access.
                </p>
                <p className='text-center text-muted mb-1'>
                    For further information you can contact <a href="mailto:help@sensoriumapp.net">help@sensoriumapp.net</a>
                </p>
                <hr className='my-5' />
              </MDBCol>
            </MDBRow>
          </MDBContainer>
        </div>
      </>
    );
  }
}

export default HomePage;
